import {Repository, RequestMethod} from 'b302-frontend-library';
import ExploreModel from '../models/ExploreModel';

class ExploreRepository extends Repository {

    public constructor() {
        super('/explore');
    }

    public all() {
        return this.request<ExploreModel[]>(this.url(), RequestMethod.GET).send();
    }
}

export default ExploreRepository;
